export enum LogicalOperator {
  Or = 0,
  And = 1,
}
